/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctDecimals } from '../../../../Fct/generics';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
export var Decimals = createPlugin({
    protocol: 'ERC20',
    type: 'GETTER',
    method: 'decimals',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'erc20',
                    options: getSupportedTokens({ chainId: chainId }),
                }),
                methodParams: {},
            },
            output: {
                decimals: new FctDecimals({ innerIndex: 0 }),
            },
        });
    },
});
